export const REGISTER_PAGE_VIEW = 'REGISTER_PAGE_VIEW';
export const registerPageView = (title, page) => dispatch => dispatch({
    type: REGISTER_PAGE_VIEW,
    title,
    page
});
